/**
 * Resolve a browser-viewable URL for the attorney-uploaded demand letter PDF.
 * Vault schemes (catalyst://, etc.) map to the local demo PDF in development.
 */

const VIEWABLE_PREFIX = /^(https?:|blob:|data:)/i;

export function demandLetterSourceUrl(matter = {}) {
  const docUrl = String(matter?.Document_Vault_URL || '').trim();
  if (docUrl) return docUrl;

  const attachments = Array.isArray(matter?.Attachments) ? matter.Attachments : [];
  const letter = attachments.find((file) => {
    const kind = String(file?.kind || '').toLowerCase();
    const name = String(file?.name || '').toLowerCase();
    return kind.includes('demand') || name.includes('demand');
  });
  return String(letter?.url || '').trim();
}

export function isDemandLetterPdf(url) {
  const raw = String(url || '').trim();
  if (!raw) return false;
  if (/\.pdf($|\?|#)/i.test(raw)) return true;
  if (raw.startsWith('data:application/pdf')) return true;
  // Vault demand documents are treated as the uploaded letter PDF.
  if (/DemandVault\/demand_/i.test(raw)) return true;
  return false;
}

/**
 * URL suitable for <iframe>/<embed> preview. Returns null when no letter yet.
 */
export function demandLetterViewerUrl(matter = {}) {
  const source = demandLetterSourceUrl(matter);
  if (!source || !isDemandLetterPdf(source)) return null;
  if (VIEWABLE_PREFIX.test(source)) return source;
  // Non-HTTP vault URIs: use demo sample so the PDF chrome is real in local/demo.
  return '/demo/demand-letter.pdf';
}

export function demandLetterFileName(matter = {}) {
  const source = demandLetterSourceUrl(matter);
  if (!source) return 'Demand letter.pdf';
  const parts = source.split('/');
  const name = parts[parts.length - 1] || 'Demand letter.pdf';
  return name.includes('.') ? name : `${name}.pdf`;
}
